import {IExchangeStatus} from '../../models/ExchangeStatus';

export const FETCH_EXCHANGE_STATUS = 'FETCH_EXCHANGE_STATUS';
export const FETCH_EXCHANGE_STATUS_SUCCESS = 'FETCH_EXCHANGE_STATUS_SUCCESS';
export const FETCH_EXCHANGE_STATUS_ERROR = 'FETCH_EXCHANGE_STATUS_ERROR';

export interface FetchExchangeStatus {
  type: typeof FETCH_EXCHANGE_STATUS;
}

export interface FetchExchangeStatusSuccess {
  type: typeof FETCH_EXCHANGE_STATUS_SUCCESS;
  payload: IExchangeStatus;
}

export interface FetchExchangeStatusError {
  type: typeof FETCH_EXCHANGE_STATUS_ERROR;
}

export type ExchangeStatusActions =
  | FetchExchangeStatus
  | FetchExchangeStatusSuccess
  | FetchExchangeStatusError;
